<div *ngIf="utilsService.isLoading">
  <app-loading></app-loading>
</div>
<div id="global-container" *ngIf="!utilsService.isLoading">
  <div id="button-cont">
    <button class="close" (click)="close()">
    <img src="assets/img/svg/close.svg" alt="close" />
    </button>
  </div>

  <div class="row" id="first">
    <div class="col-12">
      <h3 class="heading-5">
        {{ "my-bookeds.view.authorization-details" | translate }}
      </h3>
      <div class="row-data">
        <div class="icon-bcg icon-bcg--small">
          <img src="assets/img/svg/sidebar/profile.svg" alt="employee-icon" />
        </div>
        <div class="row-data-text">
          <span class="bold">{{ "authorization.labels.employee" | translate }}:
          </span>
          <span class="auth-text">{{
            authorization.userName + " " + authorization.userSurname
            }}</span>
        </div>  
      </div>
      <div class="row-data">
        <div class="icon-bcg icon-bcg--small">
          <img src="assets/img/svg/pen-black.svg" alt="pencil-icon" />
        </div>
        <div class="row-data-text">
          <span class="bold">{{ "authorization.concept" | translate }}: </span>
          <span class="auth-text">{{ authorization.description }}</span>
        </div>
      </div>
      <div class="row-data" *ngIf="authorization.requestData.travellerReason">
        <div class="icon-bcg icon-bcg--small">
          <img src="assets/img/svg/clipboard.svg" alt="clipboard-icon" />
        </div>
        <div class="row-data-text">
          <span class="bold">{{ "authorization.reason" | translate }}: </span>
          <span class="auth-text">{{ authorization.requestData.travellerReason }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row" id="second-row">
    <div class="booking-data" *ngIf="authorization.type?.toLowerCase() === 'booking'">
      <div class="row-data">
        <div class="icon-bcg icon-bcg--small">
          <img src="assets/img/svg/sidebar/hotel.svg" alt="hotel-green" />
        </div>
        <div class="row-data-text">
          <span class="bold mr-1">{{ "search.search-homepage.destiny" | translate }}:
          </span>
          <span class="auth-text">
            {{ authorization.requestData.destinationName }}
          </span>
        </div>
      </div>
      <div class="row-data">
        <div class="icon-bcg icon-bcg--small">
          <img src="assets/img/svg/calendar-black.svg" alt="calendar" />
        </div>
        <span class="bold">{{ "my-bookeds.user.entry-date" | translate }}: </span>
        <span class="auth-text">{{ fromD }}</span>
      </div>
      <div *ngIf="toD != null" class="row-data">
        <div class="icon-bcg icon-bcg--small">
          <img src="assets/img/svg/calendar-black.svg" alt="calendar" />
        </div>
        <span class="bold">{{ "my-bookeds.user.dep-date" | translate }}:</span>
        <span class="auth-text">{{ toD }}</span>
      </div>
    </div>
    <div class="no-booking-data" *ngIf="authorization.type?.toLowerCase() !== 'booking'">
      <div class="airports-container">
        <div class="row-data">
          <div class="icon-bcg icon-bcg--small">
            <img src="assets/img/svg/calendar-black.svg" alt="calendar-icon-green" />
          </div>  
          <div class="d-flex flex-wrap">
            <span class="bold">{{ "my-bookeds.user.dep-date"| translate }}: </span>
            <span class="auth-text">&nbsp;{{ fromD }}</span>
            <span class="auth-text">&nbsp;{{ getHours(authorization, true) }} </span>
          </div>
        </div>
        <div class="row-data" *ngIf="toD != null">
          <div class="icon-bcg icon-bcg--small">
            <img src="assets/img/svg/calendar-black.svg" alt="calendar" />
          </div>
          <div class="d-flex flex-wrap">
            <span class="bold">{{ "my-bookeds.user.ret-date" | translate }}:</span>
            <span class="auth-text">&nbsp;{{ toD }}</span>
            <span class="auth-text" *ngIf="getHours(authorization, false) && getHours(authorization, false) !== 'Invalid date'">&nbsp;{{ getHours(authorization, false) }}</span>
          </div>
        </div>
      </div>
      <div class="airports-container">
        <div class="row-data">
          <div class="icon-bcg icon-bcg--small">
            <img *ngIf="authorization.type?.toLowerCase() === 'train'" src="assets/img/svg/sidebar/train.svg" alt="train" />
            <img *ngIf="authorization.type?.toLowerCase() === 'flight'" src="assets/img/svg/flight-black.svg" alt="flight" />
          </div>
          <div class="d-flex flex-wrap">
            <span class="auth-text">{{ authorization.requestData.trainsInfo ?( authorization.requestData.trainsInfo.searchConfig.origin.name ? authorization.requestData.trainsInfo.searchConfig.origin.name : authorization.requestData.origin ) : authorization.requestData.from }}</span>
          </div>
        </div>
        <div class="row-data">
          <div class="icon-bcg icon-bcg--small">
            <img *ngIf="authorization.type?.toLowerCase() === 'train'" src="assets/img/svg/sidebar/train.svg" alt="train" />
            <img *ngIf="authorization.type?.toLowerCase() === 'flight' && authorization.requestData.airlines.length > 0" src="assets/img/svg/flight-black.svg" alt="flight" />
          </div>
          <div class="d-flex flex-wrap">
            <span class="auth-text">{{ authorization.requestData.trainsInfo ? (authorization.requestData.trainsInfo.searchConfig.destination.name ? authorization.requestData.trainsInfo.searchConfig.destination.name : authorization.requestData.destination) :
                authorization.requestData.to }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="title-content-container" *ngIf="authorization.type === 'flight' && authorization.requestData.airlines.length > 0">
    <div class="title">
      <span>{{'csv.flight.airline' | translate}}: </span>
    </div>
    <div class="content multiple">
      <div class="airline" *ngFor="let airline of authorization.requestData.airlines; let i = index">
        <span *ngIf="i === 0">{{'my-bookeds.train.way-going' | translate}}</span>
        <span *ngIf="i === 1">{{'my-bookeds.train.come-back' | translate}}</span>
        <img [src]="getLogo(airline)" alt="airline-logo">
      </div>
    </div>
  </div>

  <div class="title-content-container" *ngIf="authorization.type === 'train'">
    <div class="title">
      <span>{{'train.form-train.carrier' | translate}}: </span>
    </div>
    <div class="content multiple">
      <div class="airline" *ngFor="let trip of trips">
        <span>
          {{ trip.type === 'outward'
              ? ('my-bookeds.train.way-going' | translate)
              : ('my-bookeds.train.come-back' | translate) }}
        </span>
       <ng-container *ngFor="let carrier of trip.carriers">
          <img [src]="trainService.getCarrierLogo(carrier)" alt="airline-logo">
        </ng-container>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">

      <div class="title-content-container"
          *ngIf="authorization?.type?.toLowerCase() === 'flight'
                  && authorization.requestData?.scales?.length > 0
                  && hasValidScales(authorization)">
        <div class="scales-row">
          <ng-container *ngFor="let scale of authorization.requestData.scales">
            <div class="scale-block" *ngIf="scale.layovers?.length > 0">
              <div class="scale-label">
                {{
                  scale.type === 'outbound'
                    ? ('flight.detail-flight.scales-way-going' | translate)
                    : ('flight.detail-flight.scales-come-back' | translate)
                }}
              </div>
              <div class="scale-details">
                <div *ngFor="let layover of scale.layovers" class="layover">
                  <div class="route">{{ layover.from }} → {{ layover.to }}</div>
                  <div class="duration">{{ 'common.duration' | translate }}: {{ layover.duration }}</div>
                  <div class="times">
                    {{ 'train.form-train.arrival' | translate }}: {{ layover.arrivalTime }} -
                    {{ 'train.form-train.departure' | translate }}: {{ layover.departureTime }}
                  </div>
                  <div class="flight-info">
                    {{ layover.company }} {{ layover.flightNumber }}
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="title-content-container" *ngIf="authorization?.type?.toLowerCase() === 'train'">
        <div class="scales-row" *ngFor="let trip of trips">
          <div class="scale-block">
            <div class="scale-label">
              {{ trip.type === 'outward'
                  ? ('flight.detail-flight.scales-way-going' | translate)
                  : ('flight.detail-flight.scales-come-back' | translate) }}
            </div>
            <div class="scale-details">
              <div class="layover" *ngFor="let leg of trip.sections">
                <div class="route">
                  {{ leg.origin }} → {{ leg.destination }}
                </div>
                <div class="times">
                  {{ leg.departDate | date:'HH:mm' }} -
                  {{ leg.arriveDate | date:'HH:mm' }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="custom-margin">
        <span class="bold">{{ "company.company-booked.booking-type" | translate }}:</span>
        <span class="auth-text">
          {{
          (authorization.type?.toLowerCase() === "booking"
          ? "common.hotel"
          : authorization.type?.toLowerCase() === "flight"
          ? "common.flight"
          : "common.train"
          ) | translate
          }}</span>
      </div>
      <div *ngIf="authorization.requestData.fareSelected" class="fare-information-button custom-margin">
        <button class="btn btn-outline-secondary me-2" placement="left" 
        [ngbPopover]="popover">
          <img id="click-trigger" src="assets/img/svg/information.svg" />
        </button>

        <ng-template #popover>
          <li *ngFor="let service of authorization.requestData.fareSelected.services">{{service.name}}</li>
        </ng-template>
        <span class="bold">{{"my-bookeds.view.fare-name" | translate}}:</span>
        <span class="auth-text">{{authorization.requestData.fareSelected.cabin_name}}</span>
      </div>
      <div *ngIf="authorization?.type?.toLowerCase() === 'train'" class="airports-container">
        <div class="row-data">
          <span class="bold">{{"my-bookeds.view.fare-name" | translate}}:</span>
          <span class="auth-text" *ngFor="let section of authorization.requestData.trainsInfo.selectedTrains.selectedOutwardTrain?.sections">{{section?.fareName}}</span>
        </div>
        <div class="row-data">
          <span *ngIf="authorization.requestData.trainsInfo.selectedTrains.selectedReturnTrain" class="bold">{{"my-bookeds.view.fare-name" | translate}}:</span>
          <ng-container *ngIf="authorization.requestData.trainsInfo.selectedTrains.selectedReturnTrain">
            <span class="auth-text"  *ngFor="let section of authorization.requestData.trainsInfo.selectedTrains.selectedReturnTrain?.sections">{{section?.fareName}}</span>
          </ng-container>
        </div>
      </div>
      <div *ngIf="(authorization?.type?.toLowerCase() === 'flight' || authorization?.type?.toLowerCase() === 'train') && formattedTravellers" class="custom-margin">
        <span class="bold">
          {{ "my-bookeds.flight.travellers" | translate }}:
        </span>
        <span class="auth-text">{{ formattedTravellers }}</span>
      </div>

      <div
        class="baggage-row custom-margin"
        style="display: inline !important;"
        *ngIf="authorization?.type?.toLowerCase() === 'flight' && groupedBaggagesInfo.length"
      >
        <span class="bold">
          {{ 'my-bookeds.flight.baggage' | translate }}:
        </span>
        <div class="auth-text mt-1" style="margin-left: 2rem;">
          <div *ngFor="let group of groupedBaggagesInfo" class="mb-1">
            <span class="bold">{{ group.route }}: </span>
            <span>{{ group.items.join(', ') }}</span>
          </div>
        </div>
      </div>
      <div class="priority-row custom-margin" *ngIf="authorization?.type?.toLowerCase() === 'flight' && getPriorityInfo()?.length">
        <span class="bold">
          {{ 'flight.detail-flight.priority' | translate }}:
        </span>
        <div style="gap: 0 !important;" class="baggage-list-inline auth-text">
          <span style="white-space: wrap !important;" class="baggage-item" *ngFor="let priority of getPriorityInfo()">
            {{ priority.short_name }}
          </span>
        </div>
      </div>
      <div *ngIf="authorization?.type?.toLowerCase() === 'train'" class="airports-container">
        <div class="row-data" *ngIf="authorization.requestData.trainsInfo?.selectedExtras?.outward.length > 0">
          <span class="bold">{{"train.outward-extras" | translate}}:</span>
          <span *ngFor="let extra of authorization.requestData.trainsInfo?.selectedExtras?.outward" class="auth-text">{{extra.description}} - {{extra.quantity}} x {{extra.price}} €</span>
        </div>
        <div class="row-data" *ngIf="authorization.requestData.trainsInfo?.selectedExtras?.return.length > 0">
          <span class="bold">{{"train.return-extras" | translate}}:</span>
          <span *ngFor="let extra of authorization.requestData.trainsInfo.selectedExtras.return" class="auth-text">{{extra.description}} - {{extra.quantity}} x {{extra.price}} €</span>
        </div>
      </div>
      <div *ngIf="authorization?.type?.toLowerCase() === 'train'" class="airports-container">
        <div class="row-data" *ngIf="authorization.requestData.trainsInfo?.selectedSeats?.outward.length > 0">
          <span class="bold">{{"train.confirm-stepper-container.seat-selection.oneway-seats" | translate}}:</span>
          <span *ngFor="let seat of authorization.requestData.trainsInfo.selectedSeats.outward" class="auth-text">{{seat.carriage}} - {{seat.position}} - {{seat.passengersPrice[0].price}} €</span>
        </div>
        <div class="row-data" *ngIf="authorization.requestData.trainsInfo?.selectedSeats?.return.length > 0">
          <span class="bold">{{"train.confirm-stepper-container.seat-selection.back-seats" | translate}}:</span>
          <span *ngFor="let seat of authorization.requestData.trainsInfo.selectedSeats.return" class="auth-text">{{seat.carriage}} - {{seat.position}} - {{seat.passengersPrice[0].price}} €</span>
        </div>
      </div>
      <div class="flight-times-row custom-margin"
          *ngIf="authorization?.type?.toLowerCase() === 'flight' &&
                  (authorization.requestData?.totalTime?.outbound || authorization.requestData?.totalTime?.return)">
        <div *ngIf="authorization.requestData?.totalTime?.outbound">
          <span class="bold">
            {{ "flight.detail-flight.flight-time-departure" | translate }}:
          </span>
          <span class="auth-text">{{ authorization.requestData?.totalTime?.outbound }}</span>
        </div>
        <div *ngIf="authorization.requestData?.totalTime?.return" style="width: 50% !important;">
          <span class="bold">
            {{ "flight.detail-flight.flight-time-return" | translate }}:
          </span>
          <span class="auth-text">{{ authorization.requestData?.totalTime?.return }}</span>
        </div>
      </div>
      <div class="custom-margin" *ngIf="authorization.type?.toLowerCase() === 'flight' && authorization.requestData?.query?.seats?.length > 0">
        <span class="bold">
          {{ "authorization.selected-seats" | translate }}:
        </span>
        <div class="auth-text seat-info">
          <ul class="ps-3">
            <li *ngFor="let passenger of getSeatsInfoFromQuery()" class="mt-1">
              <div class="d-flex align-items-center flex-wrap">
                <span class="me-2">
                  {{ getPassengerNameByUuid(passenger.passengerUuid) || passenger.passengerUuid }}:
                </span>
                <ng-container *ngFor="let seat of passenger.seats">
                  <span class="me-3 seat-chip">
                    <strong>{{ seat.row }}{{ seat.column }} &nbsp;</strong>
                    <span *ngIf="seat.departure && seat.arrival" class="labels">
                      ({{ seat.departure }} → {{ seat.arrival }})
                    </span>
                  </span>
                </ng-container>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div *ngIf="authorization.type?.toLowerCase() === 'booking'">
        <div *ngIf="authorization.requestData?.hotel?.rooms?.[0]?.name" class="custom-margin">
          <span class="bold">{{ "hotel.room" | translate }}: &nbsp;</span>
          <span class="auth-text">{{ authorization.requestData.hotel.rooms[0].name }}</span>
        </div>
        <div *ngIf="authorization.requestData?.hotel?.rooms?.[0]?.rates?.[0]?.boardName" class="custom-margin">
          <span class="bold">{{ "user.booked.room-type" | translate }}: &nbsp;</span>
          <span class="auth-text">{{ authorization.requestData.hotel.rooms[0].rates[0].boardName }}</span>
        </div>
        <div *ngIf="authorization.requestData?.hotel?.phone" class="custom-margin">
          <span class="bold">{{ "common.phone" | translate }}: &nbsp;</span>
          <span class="auth-text">{{ authorization.requestData.hotel.phone }}</span>
        </div>
        <div *ngIf="authorization.requestData?.hotel?.postalCode" class="custom-margin">
          <span class="bold">{{ "common.postal-code" | translate }}: &nbsp;</span>
          <span class="auth-text">{{ authorization.requestData.hotel.postalCode }}</span>
        </div>
        <div *ngIf="authorization.requestData?.hotel?.stars" class="custom-margin">
          <span class="bold">{{ "common.stars" | translate }}: &nbsp;</span>
          <span class="auth-text">{{ authorization.requestData.hotel.stars }} ★</span>
        </div>
        <div *ngIf="authorization.requestData?.guests?.length > 0" class="custom-margin">
          <span class="bold">{{ "search.filters.guests" | translate }}:</span>
          <span class="auth-text">
            {{ getGuestsFullNames().join(', ') }}
          </span>
        </div>
        <div *ngIf="authorization.requestData?.comments" class="custom-margin">
          <span class="bold">{{ "authorization.comments" | translate }}: &nbsp;</span>
          <span class="auth-text text-control">{{ authorization.requestData.comments }}</span>
        </div>
      </div>
      
      <div class="custom-cost-row custom-margin"
          *ngIf="authorization?.requestData?.customCode || authorization?.requestData?.costCenter">
        <div *ngIf="authorization?.requestData?.customCode">
          <span class="bold">{{ "common.custom-code" | translate }}:</span>
          <span class="auth-text">{{ authorization.requestData.customCode }}</span>
        </div>
        <div *ngIf="authorization?.requestData?.costCenter" style="width: 50%;">
          <span class="bold">{{ "common.cost-center" | translate }}:</span>
          <span class="auth-text">{{ authorization.requestData.costCenter }}</span>
        </div>
      </div>
      <div *ngIf="authTravel?.title" class="custom-margin">
        <span class="bold">{{ 'project.associated' | translate }}: &nbsp;</span>
        <span class="auth-text">{{ authTravel.title }}</span>
      </div>

      <div *ngIf="authorization.type?.toLowerCase() === 'booking'">
        <div *ngIf="authorization.requestData.rooms[0].nameRoom">
          <span class="bold">{{'my-bookeds.view.room-name' | translate}}: </span>
          <span class="auth-text">{{authorization.requestData.rooms[0].nameRoom}}</span>
        </div>
        <div *ngIf="authorization.requestData.rooms[0].cancellationDate && authorization.requestData.rooms[0].cancellationDate[0]?.cancellationDateText">
          <span class="bold">{{'my-bookeds.view.cancellation-detail' | translate}}: </span>
          <span class="auth-text">{{authorization.requestData.rooms[0].cancellationDate && authorization.requestData.rooms[0].cancellationDate[0]?.cancellationDateText}}</span>
        </div>
        <div *ngIf="authorization?.totalAdults">
          <span class="bold">{{ "my-bookeds.view.totalAdults" | translate }}: </span>
          <span class="text">{{authorization?.totalAdults}}</span>
        </div>
        <div *ngIf="authorization?.totalRooms">
          <span class="bold">{{ "my-bookeds.view.totalRooms" | translate }}: </span>
          <span class="text">{{authorization?.totalRooms}}</span>
        </div>
      </div>
      <div class="custom-margin">
        <span class="bold">{{ "company.company-booked.status" | translate }}:</span>

        <span *ngIf="authorization.status === 'no vacancy'" class="blue-font auth-text">
          {{ "authorization.no-vacancy" | translate }}
        </span>

        <span *ngIf="authorization.status === 'accepted'" class="green-font auth-text">
          {{ "common.approved" | translate }}
        </span>

        <span *ngIf="authorization.status === 'request'" class="yellow-font auth-text">
          {{ "common.pending" | translate }}
        </span>

        <span *ngIf="authorization.status === 'denied'" class="red-font auth-text">
          {{ "common.denied" | translate }}
        </span>
      </div>
      <div class="custom-margin">
        <span class="bold">{{ "my-bookeds.view.price" | translate }}:</span>
        <span class="auth-text" *ngIf="authorization.requestData.query"> {{ authorization.requestData.query.vyooPrice | price
          }} €</span>
        <span class="auth-text" *ngIf="!authorization.requestData.query"> {{ priceFromCheck | price }} €</span>
      </div>
      <div class="custom-margin" *ngIf="authorization.type.toLowerCase() === 'flight' && authorization.requestData.annotationsExtras">
        <span class="bold">
          {{ "flight.form-flight.extras" | translate }}:
        </span>
        <span class="auth-text text-control"> {{ authorization.requestData.annotationsExtras}}</span>
      </div>
      <div class="custom-margin" *ngIf="authorization.type.toLowerCase() === 'flight' && travellersWithFFDocuments.length > 0">
        <span class="bold">
          {{ "my-bookeds.train-flight.ff-card" | translate }}:
        </span>
        <ul>
          <li *ngFor="let traveller of travellersWithFFDocuments">
            {{ traveller.fullName }}: {{ traveller.documentNumber }}
          </li>
        </ul>
      </div>
      <div class="custom-margin" *ngIf="authorization.comments !== ''">
        <span class="bold">
          {{ "my-bookeds.view.comments" | translate }}:
        </span>
        <span>{{ authorization.comments }}</span>
      </div>
      <div class="custom-margin">
        <span class="bold">{{ "common.creation-date" | translate }}: </span>
        <span class="auth-text">{{
          authorization.createdAt | dateMoment: "YYYY-MM-DD":"DD/MM/YYYY"
          }}</span>
      </div>
      <div class="custom-margin" *ngIf="authorization.response">
        <span class="bold">{{'my-bookeds.view.response' | translate}}: </span>
        <span class="auth-text">{{authorization.response}}</span>
      </div>
      <div class="custom-margin" *ngIf="authorization.requestData.adminAuthorizatorData">
        <span class="bold">{{'my-bookeds.view.admin-authorization' | translate}}: </span>
        <span class="auth-text">{{authorization.requestData.adminAuthorizatorData.name}}</span>
        <span class="auth-text"
          *ngIf="authorization.requestData.adminAuthorizatorData.lastname">&nbsp;{{authorization.requestData.adminAuthorizatorData.lastname}}</span>
      </div>
    </div>
    <div *ngIf="authorization.status.toLowerCase() === 'request' && (user.accessType?.toLowerCase() !== 'user' || user.isGroupAdmin)" class="col-12 custom-margin" id="text-area">
      <div class="textarea-container">
        <textarea required="true" class="form-control form-control--squared" #textarea placeholder="{{ 'authorization.swal.response' | translate }}"></textarea>
      </div>
    </div>
    <div class="col-12 buttons-container"
      *ngIf="authorization.status?.toLowerCase() === 'request' && (user.accessType?.toLowerCase() !== 'user' || user.isGroupAdmin)">
      <button class="custom-btn mt-2 mr-3" (click)="onDeny(authorization)">
        {{ "common.toReject" | translate }}
      </button>
      <button class="custom-btn mt-2" (click)="onAccept(authorization)">
        {{ "common.toApproved" | translate }}
      </button>
    </div>
  </div>
</div>
